import { createAuthTokenStore } from '../../services/api/authTokens';

/**
 * Jetons JWT de l'espace Ligue : même mécanisme que l'ERP (src/services/api/authTokens.js : access + refresh,
 * rafraîchissement proactif), mais stockés sous des clés propres (`mysquash.*`, celles de MySquash : une session
 * MySquash existante reste ouverte) pour ne pas se mélanger avec une session ERP sur le même domaine. La session de la
 * Ligue n'est pas liée à un club : aucun en-tête `X-Club` (rafraîchissement, déconnexion).
 */
const leagueTokens = createAuthTokenStore({
  accessKey: 'mysquash.auth.accessToken',
  refreshKey: 'mysquash.auth.refreshToken',
  /** Émis sur window quand le rafraîchissement échoue → l'AuthProvider de la Ligue ferme la session. */
  sessionExpiredEvent: 'mysquash:sessionExpired',
});

export const SESSION_EXPIRED_EVENT = leagueTokens.SESSION_EXPIRED_EVENT;

export const {
  getStoredAccessToken,
  getStoredRefreshToken,
  clearStoredAuthTokens,
  persistTokenPair,
  refreshAccessToken,
  refreshAccessTokenOnce,
  ensureAccessToken,
  logoutRemote,
  emitSessionExpired,
} = leagueTokens;
